var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"mb-6"},[_vm._v("IPTV Sources")]),_c('sources-table',{attrs:{"sources-u-r-l":"/api/management/v1/source/","marked-sources":_vm.inUse}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }